export const DEFAULT_COLOR = '#CCCCCC';

export const COLORS_FORMA = {
  'nps-promoters': 'var(--forma-result-super-green, #3faf87)',
  'nps-passive': 'var(--forma-result-neutral, #C4C4C4)',
  'nps-detractors': 'var(--forma-result-red, #e46b74)',
  '3grade-high': 'var(--forma-result-super-green, #3faf87)',
  '3grade-medium': 'var(--forma-result-yellow, #fddd91)',
  '3grade-low': 'var(--forma-result-red, #e46b74)',
  '5grade-highest': 'var(--forma-result-super-green, #3faf87)',
  '5grade-high': 'var(--forma-result-mint-green, #8fd8bc)',
  '5grade-medium': 'var(--forma-result-yellow, #fddd91)',
  '5grade-low': 'var(--forma-result-orange, #f6a36c)',
  '5grade-lowest': 'var(--forma-result-red, #e46b74)',
  warning: 'var(--forma-result-red, #e46b74)',

  'tonality-positive': 'var(--forma-result-mint-green, #8fd8bc)',
  'tonality-neutral': 'var(--forma-result-neutral, #C4C4C4)',
  'tonality-negative': 'var(--forma-result-orange, #f6a36c)',

  'ei-index-bar': 'var(--forma-result-mint-green, #8fd8bc)',
  'ei-darkgreen': 'var(--forma-result-super-green, #3faf87)',
  'ei-green': 'var(--forma-result-mint-green, #8fd8bc)',
  'ei-blue': 'var(--forma-result-blue, #6f96e6)',
  'ei-yellow': 'var(--forma-result-yellow, #fddd91)',
  'ei-red': 'var(--forma-result-red, #e46b74)',
  'scaled-index-darkgreen': 'var(--forma-result-super-green, #3faf87)',
  'scaled-index-green': 'var(--forma-result-mint-green, #8fd8bc)',
  'scaled-index-yellow': 'var(--forma-result-yellow, #fddd91)',
  'scaled-index-red': 'var(--forma-result-red, #e46b74)',
  'scaled-index-blue': 'var(--forma-result-blue, #6f96e6)',
  'scaled-index-ei_darkgreen': 'var(--forma-result-super-green, #16AA4E)',
  'scaled-index-ei_green': 'var(--forma-result-mint-green, #8FE5A1)',
  'scaled-index-ei_yellow': 'var(--forma-result-yellow, #FFD800)',
  'scaled-index-ei_red': 'var(--forma-result-red, #FB091F)',
  'scaled-index-ei_blue': 'var(--forma-result-blue, #1F4AE9)',
  transparent: 'rgba(0, 0, 0, 0)',

  'color-lavender-dark': '#4A318E',
  'color-lavender-medium': '#785DF1',
  'color-lavender-light': '#C9BFFB',
  'color-lavender-lightest': '#F5F3FF',
};

export function getColor(c: string, defaultColor: string = DEFAULT_COLOR): string {
  if (!c) {
    return defaultColor;
  }
  if (c.startsWith('#')) {
    return c;
  }
  return (COLORS_FORMA[c] ?? defaultColor) as string;
}

export enum ColorLevel {
  Darkest = 0,
  Dark,
  Medium,
  Light,
  Lightest,
}

export enum GraphColor {
  Blue = 'blue',
  Orange = 'orange',
  Purple = 'purple',
  Green = 'green',
  Yellow = 'yellow',
  Red = 'red',
}

const BLUE = {
  name: 'blue',
  values: ['#D5EBFF', '#8AC6FF', '#79A5FF', '#0334AE', '#15357E', '#0C2452', '#030E21'],
};
const ORANGE = {
  name: 'orange',
  values: ['#FFE0B2', '#FFCB58', '#F0A444', '#D9752A', '#AE5113', '#863D13', '#5F2B11'],
};
const PURPLE = {
  name: 'purple',
  values: ['#F5D9FF', '#C795E4', '#8E57C2', '#7B40AE', '#642D91', '#4A0F66', '#2A0637'],
};
const GREEN = {
  name: 'green',
  values: ['#D0EDE7', '#9EDBD2', '#3AA7A0', '#1B8A86', '#006E6D', '#005251', '#003B3A'],
};
const YELLOW = {
  name: 'yellow',
  values: ['#FFF0BF', '#FFDB63', '#EDC228', '#D29F00', '#B18600', '#8A6D00', '#5E4A00'],
};
const RED = {
  name: 'red',
  values: ['#F6D5D6', '#E3777D', '#D9454D', '#AE232B', '#8C1D23', '#6A161A', '#501014'],
};

export class GraphColors {
  static colors = [BLUE, ORANGE, PURPLE, GREEN, YELLOW, RED];

  static getColorOfSet(index: number, level?: number, numberOfSets?: number) {
    if (numberOfSets > Object.keys(ColorLevel).length / 2) {
      return GraphColors.getColorStatic(level, index);
    }
    return GraphColors.getColorStatic(index, level);
  }

  static getColorStatic(param: string | number, level: undefined | ColorLevel = 1): string {
    if (typeof param === 'string') {
      const item = this.colors.find((c) => c.name === param);
      return item ? item.values[+level] : DEFAULT_COLOR;
    } else {
      const levelLength = Object.keys(ColorLevel).length / 2;
      const item = this.colors[param % this.colors.length];
      if (!!level) {
        return item ? item.values[+level % levelLength] : DEFAULT_COLOR;
      }
      return item ? item.values[Math.floor((param / levelLength) % levelLength)] : DEFAULT_COLOR;
    }
  }
}
